<template>
  <div>
    <div class="add_tits" ref="titles">
      <el-form class="form-inlines u-f u-jsb" :inline="true">
        <!-- <div>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="begin"
              >搜索</el-button
            >
          </el-form-item>
        </div> -->
        <div>
          <el-form-item>
            <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="ibox-content">
      <el-table :data="tableData" border v-loading="loading" height="500" class="tableLimit">
        <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>
        <el-table-column prop="id" label="用户id" show-overflow-tooltip></el-table-column>
        <el-table-column prop="user.username" label="用户昵称" width="150">
          <template slot-scope="{ row }">
            <span v-if="row.is_fictitious == 1">{{ row.user.username }}</span>
            <span v-if="row.is_fictitious == 2">{{ row.users.username }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="send_id" label="发帖Id" show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" label="发帖内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="图片">
          <template slot-scope="scope">
            <div class="u-f u-wrap">
              <div @click="goprev(scope.row.titlepic)">
                <img :src="scope.row.titlepic" alt="" width="50" class="tablimg" />
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="detailbtn(scope.row,scope.$index)">详情</el-button>
                        <el-button size="mini" type="danger" @click="handleDelet(scope.row,scope.$index)">删除</el-button>
                    </template>
                </el-table-column> -->
      </el-table>
      <div class="u-f u-ac u-jsb ft_mr">
        <div></div>
        <div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="count">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="录入" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs"
      :append-to-body="true">
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm forms-lines">
          <el-form-item label="人员" prop="ry_value">
            <el-select v-model="ruleForm.ry_value" placeholder="请选择" size="small" filterable @change="selectUser">
              <el-option v-for="item in ry_options" :key="item.id" :label="item.username + '--' + item.sex_text"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片">
            <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
              :headers="{ token: $store.state.user.token }" :data="{
                image_class_id: '72',
                file_type: '1',
                userId: this.ruleForm.ry_value,
              }" :file-list="ruleForm.lb_mapList" :before-upload="beforeUpload" :on-success="uploadSuccess" :limit="1"
              :on-remove="uploadRmove" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="关键词" prop="keyword">
            <el-input v-model="ruleForm.keyword" placeholder="请输入关键词" size="small" class="zwidth">
            </el-input>
          </el-form-item>

          <el-form-item label="内容" prop="textareas">
            <Tinymce ref="editor" :key="commany" v-model="ruleForm.textareas"
              toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload">
            </Tinymce>
          </el-form-item>
          <el-form-item label="发布设置" prop="lb_put">
            <el-radio-group v-model="ruleForm.lb_put">
              <el-radio :label="1" style="width: 100%; margin-bottom: 0px">立即发布</el-radio>
              <div>
                <el-radio :label="2">定时发布</el-radio>
                <el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
                  :disabled="ruleForm.lb_put == 2 ? false : true" size="mini" type="datetime"
                  value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
                </el-date-picker>
              </div>
              <el-radio :label="3" style="width: 100%">暂不发布</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="detaildialogVisible" center top="20px" width="70%" class="dialogs"
      :append-to-body="true">
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <el-form :model="getruleForm" :rules="rule" ref="ruleForm" label-width="150px"
          class="demo-ruleForm forms-lines">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户:">
                <p class="yhname">{{ getruleForm.rytext }}</p>
              </el-form-item>

              <el-form-item label="话题:">
                <p>{{ topic_info.title }}</p>
              </el-form-item>

              <el-form-item label="内容:">
                <p class="con_de" v-html="getruleForm.textarea"></p>
              </el-form-item>
              <el-form-item label="图片:">
                <div v-if="getruleForm.images">
                  <div class="imgbox">
                    <div class="singleimg">
                      <img :src="getruleForm.images" alt="" />
                    </div>
                  </div>
                </div>
                <div v-else>无图片</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="人员" prop="ry_value2">
                <el-select v-model="getruleForm.ry_value2" placeholder="请选择" size="small" filterable @change="selectry">
                  <el-option v-for="item in ry_options" :key="item.id" :label="item.username + '--' + item.sex_text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="赞一下">
                <div class="zanbtn" @click="dzan">
                  <img v-if="!zan" src="../../../../assets/imgs/zan.png" alt="" />
                  <img v-else src="../../../../assets/imgs/zan2.png" alt="" />
                </div>
              </el-form-item>
              <el-form-item label="评论" prop="pltext">
                <el-input type="text" placeholder="评论一下" v-model="getruleForm.pltext">
                </el-input>
              </el-form-item>
              <el-form-item label="评论:">
                <div class="lefts" v-if="listItem && listItem.length > 0">
                  <el-timeline :reverse="true">
                    <el-timeline-item v-for="(item, index) in listItem" :key="index" :timestamp="item.create_time"
                      placement="top">
                      <div class="concon">
                        <div class="u-f u-ac u-jsb">
                          <div class="u-f u-ac u-jsb" style="width: 100%">
                            <div class="u-f u-ac">
                              <img :src="
                                  item.is_fictitious == 1
                                    ? item.user.userpic
                                    : item.users.userpic
                                " alt="" class="imgs" />
                              <div>
                                {{
                                  item.is_fictitious == 1
                                    ? item.user.username
                                    : item.users.username
                                }}
                              </div>
                            </div>
                            <div>
                              <i class="el-icon-delete reds" @click="delclick(item)"></i>
                            </div>
                          </div>
                        </div>
                        <div class="">{{ item.content }}</div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                </div>
                <div v-else>暂无评论</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="plsubmit" size="small" type="primary" :loading="subloading">提 交</el-button>
        <el-button @click="detaildialogVisible = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
      <div style="margin: -60px -20px -30px -20px">
        <img :src="urls" class="w-100" />
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import {
    mapState
  } from "vuex";
  import Tinymce from "@/components/common/tinymce.vue";
  export default {
    components: {
      Tinymce,
    },
    data() {
      return {
        commany: 1,
        topic_info: "",
        gcid: "",
        lb_value: "",
        ry_options: [],
        loading: false,
        tableData: [],
        count: 0,
        currentPage: 1,
        pagesize: 10,
        height: null,
        //
        eid: "0",
        dialogVisible: false,
        detaildialogVisible: false,
        subloading: false,
        dataId: "",
        listItem: [],

        ruleForm: {
          keyword: "",
          lb_mapList: [],
          ry_value: "",
          textareas: "",
          lb_dstime: "",
          lb_put: 1,
        },

        getruleForm: {
          rytext: "",
          pltext: "",
          textarea: "",
          images: "",
          ry_value2: "",
        },
        zan: false,
        mapListed: [],
        rule: {
          textareas: [{
            required: true,
            message: "请填写内容",
            trigger: "blur",
          }, ],
          ry_value: [{
            required: true,
            message: "请选择人员",
            trigger: "blur",
          }, ],
          keyword: [{
            required: true,
            message: "请填写关键词",
            trigger: "blur",
          }, ],
        },
        //
        dialog_prev: false,
        urls: "",
      };
    },
    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
    },
    created() {
      if (sessionStorage.getItem("xuniUsers")) {
        this.ry_options = JSON.parse(sessionStorage.getItem("xuniUsers"));
      } else {
        this.getxnUser();
      }
    },
    mounted() {
      let that = this;
    },
    methods: {
      getxnUser() {
        this.axios
          .post(
            "/admin/h5/fictitiousUsers", {
              page: 1,
              page_count: 3000,
            }, {
              token: true,
            }
          )
          .then((res) => {
            this.ry_options = res.data.data.list;
            sessionStorage.setItem(
              "xuniUsers",
              JSON.stringify(res.data.data.list)
            );
          })
          .catch((err) => {});
      },
      selectUser(val) {
        this.ry_options.forEach((e) => {
          if (e.id == val) {
            this.selectUserdata = e;
          }
        });
      },
      // 搜索
      begin() {
        let that = this;
        that.currentPage = 1;
        that.pagesize = 10;
        that.search();
      },
      search() {
        let that = this;
        that.tableData = [];
        that.loading = true;
        axios
          .post(
            `admin/getTopicPost`, {
              page: this.currentPage,
              topic_id: that.gcid,
              userId: this.user.id,
              page_count: this.pagesize,
              ht: 1,
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.loading = false;
            that.tableData = response.data.data.list.data;
            that.count = response.data.data.list.count;
            that.topic_info = response.data.data.list.topic_info;
          })
          .catch((error) => {});
      },
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
        that.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.search();
      },
      handleAdd() {
        let that = this;
        that.dialogVisible = true;
        that.eid = "0";
        this.commany += 1;
        that.form_clear();
      },
      form_clear() {
        let that = this;
        this.ruleForm.textareas = "";
        that.ruleForm.keyword = "";
        that.ruleForm.lb_put = 1;
        that.ruleForm.lb_dstime = "";
        that.ruleForm.lb_mapList = [];
        that.ruleForm.ry_value = "";
        that.mapListed = [];
      },
      submit(formName) {
        let that = this;
        var time;
        if (that.ruleForm.lb_put == "1") {
          time = that.gettimes();
        } else if (that.ruleForm.lb_put == "2") {
          time = that.ruleForm.lb_dstime;
        } else {
          time = that.ruleForm.lb_put;
        }
        that.$refs[formName].validate((valid) => {
          if (valid) {
            // if (that.mapListed.length < 1) return that.$message.error('请上传图片');
            var arr1 = [];
            that.mapListed.forEach((ele) => {
              var obj = {
                id: ele.id
              };
              arr1.push(obj);
            });
            that.subloading = true;
            let urls;
            if (this.eid && this.eid != "0") {
              urls = "/admin/pc/updatePost";
            } else {
              urls = "/admin/pc/post/create";
            }
            axios
              .post(
                urls, {
                  anonymous:0,
                  id: that.eid,
                  imglist: arr1,
                  text: this.ruleForm.textareas,
                  isopen: 1,
                  topic_id: this.gcid,
                  post_class_id: this.lb_value,
                  userId: this.ruleForm.ry_value,
                  keyword: this.ruleForm.keyword,
                  to_show: that.ruleForm.lb_put,
                  show_time: time,
                  is_fictitious: 2,
                  status: 1,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                that.subloading = false;
                if (response.data.code == "200") {
                  that.dialogVisible = false;
                  that.search();
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {
                that.subloading = true;
              });
          } else {
            this.$alert("信息遗漏未填");
            return false;
          }
        });
      },
      //编辑
      handleEdit(row, index) {
        let that = this;
        that.dialogVisible = true;
        this.commany += 1;
        that.ruleForm.keyword = "";
        that.ruleForm.lb_mapList = [];
        that.ruleForm.ry_value = "";
        that.mapListed = [];
        this.mapListed = row.images;
        this.ruleForm.lb_mapList = row.images;
        that.eid = row.id;
        this.ruleForm.lb_dstime = row.show_time;
        this.ruleForm.lb_put = row.to_show;
        this.ruleForm.textareas = "";
        this.ruleForm.textareas = row.content;
        if (row.is_fictitious == 2) {
          that.ruleForm.ry_value = row.users.id;
        } else {
          that.ruleForm.ry_value = "";
        }
        that.ruleForm.keyword = row.keyword;
      },

      plsubmit() {
        if (!this.getruleForm.ry_value2) {
          return this.$message({
            message: "请先选择人员哦",
            type: "warning",
          });
        }
        if (!this.getruleForm.pltext) {
          return this.$message({
            message: "评论不能为空",
            type: "warning",
          });
        }
        axios
          .post(
            "/admin/pc/comment", {
              post_id: this.dataId,
              dataId: this.dataId,
              fid: 0,
              content: this.getruleForm.pltext,
              userId: this.getruleForm.ry_value2,
              is_fictitious: 2,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "评论成功",
                type: "success",
              });
              this.detaildialogVisible = false;
            }
          });
      },
      detailbtn(row, index) {
        this.dataId = row.id;
        this.zan = false;
        this.detaildialogVisible = true;
        this.getinfo();
        this.getruleForm.rytext =
          row.is_fictitious == 2 ? row.users.username : row.user.username;
        this.getruleForm.pltext = "";
        this.getruleForm.ry_value2 = "";
        this.getruleForm.images = row.titlepic;
        this.getruleForm.textarea = row.content;
      },
      // 删除
      handleDelet(row, index) {
        let that = this;
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            axios
              .post(
                "/admin/delPost", {
                  id: row.id,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == "200") {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  that.search();
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      gettimes() {
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        let hour = nowDate.getHours(); //获取系统时，
        let min = nowDate.getMinutes(); //分
        let sec = nowDate.getSeconds(); //秒
        month = month > 9 ? month : "0" + month;
        day = day > 9 ? day : "0" + day;
        hour = hour > 9 ? hour : "0" + hour;
        min = min > 9 ? min : "0" + min;
        sec = sec > 9 ? sec : "0" + sec;
        return `${year}-${month}-${day} ${hour}:${min}`;
      },
      // 获取人员
      getper() {
        let that = this;
        axios
          .post(
            `/admin/doctorAssistantList`, {}, {
              token: true,
            }
          )
          .then((response) => {
            that.ry_options = response.data.data;
          })
          .catch((error) => {});
      },
      goprev(item) {
        let that = this;
        that.dialog_prev = true;
        that.urls = item;
      },
      getinfo() {
        let that = this;
        axios
          .get(`/admin/post/${this.dataId}/comment`, {
            token: true,
          })
          .then((response) => {
            that.listItem = response.data.data.list;
          })
          .catch((error) => {});
      },
      selectry() {
        this.zan = false;
      },
      dzan() {
        if (!this.getruleForm.ry_value2) {
          this.$message({
            message: "请先选择人员哦",
            type: "warning",
          });
          return;
        }
        axios
          .post(
            "/admin/pc/support", {
              post_id: this.dataId,
              type: 0,
              userId: this.getruleForm.ry_value2,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200 && res.data.errorCode == 999) {
              this.$message({
                message: "已经赞过了",
                type: "success",
              });
            } else {
              this.$message({
                message: "点赞成功",
                type: "success",
              });

              this.zan = true;
            }
          });
      },
      beforeUpload() {
        if (!this.ruleForm.ry_value) {
          return this.$message({
            message: "请先选择人员哦",
            type: "warning",
          });
        }
      },
      //
      uploadSuccess(response, file, fileList) {
        let that = this;
        if (response.code == "201") {
          that.$nextTick(() => {
            let mainImg = that.$refs.upload;
            if (mainImg) {
              mainImg.uploadFiles.forEach((element, index) => {
                if (file.uid == element.uid) {
                  mainImg.uploadFiles.splice(index, 1);
                }
              });
            }
          });
          that.$alert(response.msg);
          return;
        }
        that.$message({
          message: "上传成功",
          type: "success",
        });
        that.mapListed.push(response.data);
      },
      uploadRmove(file, fileList) {
        this.mapListed = [];
      },

      delclick(row) {
        let that = this;
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            axios
              .post(
                "/admin/pc/delComment", {
                  id: row.id,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == "200") {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  that.getinfo();
                } else {
                  that.$message.error(response.data.msg);
                }
              })
              .catch((error) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      handleDelete() {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            let url = `/admin/pc/delPost`;
            axios
              .post(
                url, {
                  id: this.dataId,
                }, {
                  token: true,
                }
              )
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {}
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
    },
  };
</script>


<style>
  .con_de {
    /* border: 1px solid red; */
    /* width: 200px; */
    width: 100%;
    max-height: 200px;
    overflow-y: scroll;
    line-height: 18px;
    position: relative;
    top: 7px;
    background-color: rgb(247, 245, 245);
    border-radius: 5px;
    padding: 5px;
  }

  .imgs {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .lefts {
    max-height: 500px;
    overflow: auto;
  }

  .delt {
    color: red;
    font-size: 20px;
  }

  .blues {
    color: #409eff;
  }

  .concon {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 10px;
  }

  .zanbtn {
    width: 30px;
    display: flex;
    /* border: 1px solid red; */
    cursor: pointer;
  }

  .zanbtn img {
    width: 100%;
    display: block;
  }

  .singleimg {
    width: 100px;
    width: 100px;
  }

  .singleimg img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .imgbox {
    display: flex;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .tablimg {
    margin: 2px 5px;
  }
</style>